import { QueryStatus, useQuery } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetAvailableProgramInstituteCoursesRequestObjectSchema,
  GetAvailableProgramInstituteCoursesResponseSchema,
  GetAvailableProgramInstituteCoursesResponseType
} from '../../../services/NwProductsExtensionsServices/APIService/types';

import { useNwProductsExtensionsService } from '../useNwProductsExtensionsService';

interface UseGetAvailableProgramInstituteCoursesApiInterface {
  data: GetAvailableProgramInstituteCoursesResponseType | undefined;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: QueryStatus;
  refetch: () => Promise<unknown>;
  isFetching: boolean;
}

const useGetAvailableProgramInstituteCoursesApi = (
  programId: number,
  enabled = true
): UseGetAvailableProgramInstituteCoursesApiInterface => {
  const { nwProductsExtensionsServiceInstance } =
    useNwProductsExtensionsService();

  const getAvailableProgramInstituteCourses = () => {
    const requestObject = { program_id: programId };
    try {
      GetAvailableProgramInstituteCoursesRequestObjectSchema.parse(
        requestObject
      );
    } catch (error) {
      console.error('Invalid request object:', error);
      throw error;
    }

    return nwProductsExtensionsServiceInstance
      .getAvailableProgramInstituteCourses(requestObject)
      .then((response) => {
        try {
          GetAvailableProgramInstituteCoursesResponseSchema.parse(response);
        } catch (error) {
          console.error('Invalid response object:', error);
          throw error;
        }
        return response;
      });
  };

  const { data, isLoading, isError, error, status, refetch, isFetching } =
    useQuery(
      ['getAvailableProgramInstituteCourses', programId],
      getAvailableProgramInstituteCourses,
      {
        enabled: Boolean(programId) && enabled,
        staleTime: 60000
      }
    );

  return {
    data,
    isLoading,
    isError,
    error: error ? getAPIErrorMessage(error) : null,
    status,
    refetch,
    isFetching
  };
};

export { useGetAvailableProgramInstituteCoursesApi };
